
export namespace SQLEnum
{
	export type Bool = 0 | 1;
	export type OrderStep = "CREATED" | "PAID" | "PROCESSED" | "SHIPPED" | "CANCELLED";
	export type PaymentMethod = "CARD" | "PHONE" | "BANK";
	export type ProductVisibility = "PUBLIC" | "VISIBLE" | "INVISIBLE" | "PRIVATE";
	export type AttribType = "BRAND" | "CATEGORY";
	export type UserPermission = "CUSTOMER" | "STAFF" | "ADMIN" | "PRACTITIONER";
	export type Logger = "INFO" | "WARNING" | "ERROR" | "FATAL";
	export type QuantityType = "G" | "ML";
	export type CountryState = "TAXED" | "UNTAXED" | "BLOCKED";

	export namespace A
	{
		export const OrderStep = ["CREATED", "PAID", "PROCESSED", "SHIPPED", "CANCELLED"];
		export const PaymentMethod = ["CARD", "PHONE", "BANK"];
		export const ProductVisibility = ["PUBLIC", "VISIBLE", "INVISIBLE", "PRIVATE"];
		export const AttribType = ["BRAND", "CATEGORY"];
		export const UserPermission = ["CUSTOMER", "STAFF", "ADMIN", "PRACTITIONER"];
		export const Logger = ["INFO", "WARNING", "ERROR", "FATAL"];
		export const QuantityType = ["G", "ML"];
		export const CountryState = ["TAXED", "UNTAXED", "BLOCKED"];
	}
}
